import { createTheme as createMuiTheme } from '@mui/material/styles';

export const theme = {
  primaryBackgroundLight: "#ffffff",
  primaryPurple: "#2E2E2E",
  primaryColorLight: "#ffffff",  // Para texto en botones oscuros
  primaryGray: "#4a4a4a",         // Gris para iconos/textos

  button: {
    primary: "#2E2E2E",
    primaryHover: "#1c1c1c",
    primaryBorder: "#2E2E2E",
    primaryBorderHover: "#1c1c1c",
    buttonHoverShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.25)",
  },

  sidebar: {
    selected: "#2E2E2E",
    selectedText: "#ffffff",
  },

  tabs: {
    border: "#8051FF",
    selected: "#8051FF",
  },

  pagination: {
    selectedBackground: "#E8DEFF",
    selectedText: "#3E2666",
  },

  primary: {
    purple: "#2E2E2E",
    purpleLight: "#4a4a4a",
    purpleDark: "#2e2e2e",
    purpleMedium: "#3a3a3a",
    purpleHover: "rgba(46, 46, 46, 1)",
    purplePink: "#2E2E2E",
    purpleFade: "#2e2e2e47",
    purpleFadeDark: "#2e2e2ecf",
    purpleOpacity: "rgba(46, 46, 46, 1)",
    purpleLightOpacity: "rgba(46, 46, 46, 0.5)",
    pinkLight: "#ffbbdc",
    pinkLightOpacity: "#ffbbdc33",
    pinkBackground: "#fff1f8",
    green: "#33cf8d",
    greenDark: "#04B469",
    greenRgba: "rgba(4, 180, 105, 1)",
    blue: "#0087ff",
    blueLight: "#0084ff",
    blueDark: "#002c81",
    bluePale: "#d3e1fc",
    teal: "#008a98",
    tealLight: "#00af9b",
    red: "#ff0202",
    redDark: "#cc0000",
    redDarkBrand: "#eb0027",
    redRgba: "rgba(204, 0, 0, 1)",
    redLight: "#ff0000",
    redPale: "#ffd7d7",
    orange: "#f6921e",
    orangeDeep: "#ff6f00",
    orangeLight: "#ffc966",
    yellow: "#ffd700",
    yellowLight: "#ffdd15",
    yellowPale: "#fff7da",
    yellowDark: "#5b4900",
    indigo: "#3047b0",
    purpleAccent: "#6a6a6a",
    secondaryPurple: "#2E2E2E",
    primaryLight: "#2E2E2E",
    secondaryPinkLightOne: "#2E2E2E",
    redDarkCategory: "#cf402c",
    icon: "#8f9bb3",
    gradient: "linear-gradient(180deg, #2E2E2E 0%, #2E2E2E 100%)",
  },

  neutral: {
    white: "#ffffff",
    black: "#000000",
    iconGray: "#73738B",
    lightGray: "#9c9696",
    primaryBackgroundLight: "#ffffff",
    gray: {
      100: "#f2f2f2",
      200: "#f0f0f0",
      300: "#eeeeee",
      400: "#e6e6e6",
      500: "#e4e4e4",
      600: "#dddddd",
      700: "#d9d9d9",
      800: "#d2d2d2",
      900: "#cccccc",
      950: "#c1c1c1",
      960: "#bfbfbf",
      970: "#bdbdbd",
      980: "#b7b7b7",
      990: "#adadad",
      1000: "#a9a9a9",
      1100: "#a5a5a5",
      1200: "#999999",
      1300: "#989898",
      1400: "#8f8888",
      1500: "#838383",
      1600: "#808080",
      1700: "#777777",
      1800: "#757575",
      1900: "#747474",
      2000: "#737373",
      2100: "#70727b",
      2200: "#6b6b6b",
      2300: "#646464",
      2400: "#616161",
      2500: "#5f5f5f",
      2600: "#5d5d5d",
      2700: "#4f4f4f",
      2800: "#4e4e4e",
      2900: "#494949",
      3000: "#3b3b3b",
      3100: "#2f2f2f",
      3200: "#2e2e2e",
      3300: "#2d2d2d",
      3400: "#232323",
      3500: "#222222",
      3600: "#1c1c1c",
      3700: "#1b1b1b",
      3800: "#181818",
      3900: "#111111",
    },
  },

  text: {
    primary: "#2e2e2e",
    secondary: "#646464",
    light: "#ffffff",
    dark: "#000000",
    muted: "#6b6b6b",
    placeholder: "#999999",
    disabled: "#bfbfbf",
  },

  background: {
    primary: "#ffffff",
    secondary: "#f0f0f0",
    tertiary: "#f7f7f7",
    light: "#fafafa",
    dark: "#2e2e2e",
    overlay: "rgba(0, 0, 0, 0.5)",
  },

  border: {
    light: "#e4e4e4",
    medium: "#cccccc",
    dark: "#999999",
    purple: "#2E2E2E",
    purpleLight: "#d0d0d0",
  },

  shadows: {
    light: "rgba(0, 0, 0, 0.12)",
    medium: "rgba(0, 0, 0, 0.18)",
    strong: "rgba(0, 0, 0, 0.25)",
    veryStrong: "rgba(0, 0, 0, 0.5)",
    button: "rgba(46, 46, 46, 0.5)",
  },

  status: {
    success: "#33cf8d",
    successDark: "#04B469",
    successLight: "#7DD37C",
    successBackground: "#e8f5e9",
    error: "#ff0202",
    errorDark: "#ca2c2c",
    errorLight: "#ff0000",
    errorPale: "#ff0c00",
    warning: "#f6921e",
    warningLight: "#ffc966",
    warningBackground: "#fff7da",
    warningPale: "#FBD860",
    info: "#0087ff",
    infoLight: "#3498db",
    infoPale: "#0084FF",
    inactive: "#BFBFBF",
  },

  font: {
    primary: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    primaryFontFamily: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    secondary: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    secondaryFontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    secondaryFontFamilyTwo: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    secondaryFontFamilyFour: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    tertiary: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    quaternary: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    quinary: "'TP Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    light: "'TP Sans Light', 'TP Sans', sans-serif",
    medium: "'TP Sans Medium', 'TP Sans', sans-serif",
    bold: "'TP Sans Bold', 'TP Sans', sans-serif",
  },
};

export const muiTheme = createMuiTheme({
  ...theme,
  button: {
    primary: theme.button.primary,
    primaryHover: theme.button.primaryHover,
    primaryBorder: theme.button.primaryBorder,
    primaryBorderHover: theme.button.primaryBorderHover,
    buttonHoverShadow: theme.button.buttonHoverShadow,
  },
  palette: {
    ...theme.palette,
    primary: {
      main: theme.primary.purple,
      light: theme.primary.purpleLight,
      dark: theme.primary.purpleDark,
    },
    button: {
      primary: theme.button.primary,
      primaryHover: theme.button.primaryHover,
      primaryBorder: theme.button.primaryBorder,
    },
    secondary: {
      main: theme.primary.blue,
    },
    success: {
      main: theme.status.success,
      dark: theme.status.successDark,
    },
    error: {
      main: theme.status.error,
      light: theme.status.errorLight,
      dark: theme.status.errorDark,
    },
    warning: {
      main: theme.status.warning,
      light: theme.status.warningLight,
    },
    info: {
      main: theme.status.info,
      light: theme.status.infoLight,
    },
    background: {
      default: theme.background.primary,
      paper: theme.background.secondary,
    },
    text: {
      primary: theme.text.primary,
      secondary: theme.text.secondary,
      disabled: theme.text.disabled,
      hint: theme.text.placeholder,
    },
  },
  typography: {
    fontFamily: theme.font.quaternary,
  },
  components: {
    MuiCircularProgress: {
      defaultProps: {
        color: 'primary',
      },
      styleOverrides: {
        root: {
          color: theme.button.primary,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiTablePagination-actions button.Mui-selected': {
            backgroundColor: theme.pagination.selectedBackground,
            color: theme.pagination.selectedText,
          },
          '& .MuiTablePagination-actions button.Mui-focusVisible': {
            backgroundColor: theme.pagination.selectedBackground,
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.pagination.selectedBackground,
            color: theme.pagination.selectedText,
          },
        },
      },
    },
  },
});

export const colors = {
  ...theme.primary,
  ...theme.neutral,
  ...theme.text,
  ...theme.background,
  ...theme.border,
  ...theme.status,
};

export const getColor = (path) => {
  const keys = path.split(".");
  let value = theme;
  for (const key of keys) {
    value = value?.[key];
  }
  return value;
};
